import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: 'Noto Sans JP',
    body1: {
      fontSize: '14px'
    },
    body2: {
      fontSize: '14px'
    }
  },
  palette: {
    primary: {
      main: '#23B7E5',
      dark: '#434154',
      light: '#FFFFFF',
      contrastText: "#FFFFFF"
    },
    secondary: {
      main: '#3061C2',
      contrastText: '#A3AED0'
    },
    background: {
      default: '#FAFAFA'
    }
  },
  components: {
    MuiLink: {
      styleOverrides: {
        root: {
          fontFamily: 'Noto Sans JP'
        }
      }
    }
  }
});

export default theme;
